import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ae3642c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "student-import-container" }
const _hoisted_2 = { class: "main" }
const _hoisted_3 = { class: "main-header" }
const _hoisted_4 = { class: "main-body" }
const _hoisted_5 = { class: "controls-area" }
const _hoisted_6 = { class: "controls-area-right" }
const _hoisted_7 = {
  key: 0,
  class: "data-area saving"
}
const _hoisted_8 = {
  key: 1,
  class: "data-area table-wrap"
}
const _hoisted_9 = {
  key: 2,
  class: "data-area preview"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "preview-text" }, "Preview", -1))
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StudentSubPageHeading = _resolveComponent("StudentSubPageHeading")!
  const _component_UploadArea = _resolveComponent("UploadArea")!
  const _component_StudentImportSchoolYearArea = _resolveComponent("StudentImportSchoolYearArea")!
  const _component_ConfirmImportButton = _resolveComponent("ConfirmImportButton")!
  const _component_LoadingBlock = _resolveComponent("LoadingBlock")!
  const _component_StudentListTable = _resolveComponent("StudentListTable")!
  const _component_StudentColumnsSelect = _resolveComponent("StudentColumnsSelect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_StudentSubPageHeading, {
          class: "page-heading",
          "sub-label": "Student Import",
          "main-page-heading-link-path": "/student",
          "on-click-back": _ctx.onClickBack
        }, null, 8, ["on-click-back"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_UploadArea, {
            class: "upload-area",
            "main-text": "ここにCSVファイルをドロップ",
            "button-text": "CSVファイルを選択",
            accept: "text/csv",
            "on-select-file": _ctx.onSelectFile,
            "on-unselect-file": _ctx.onUnselectFileInternal
          }, null, 8, ["on-select-file", "on-unselect-file"]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_StudentImportSchoolYearArea, {
              class: "school-year-area",
              "school-year": _ctx.schoolYear,
              "on-input": _ctx.onInputSchoolYear,
              enabled: !_ctx.fileLoaded
            }, null, 8, ["school-year", "on-input", "enabled"]),
            _createVNode(_component_ConfirmImportButton, {
              class: "confirm-button",
              enabled: _ctx.students.hasFreshData && !_ctx.saving,
              "on-click": _ctx.onConfirmImport
            }, null, 8, ["enabled", "on-click"])
          ])
        ]),
        (_ctx.saving)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_LoadingBlock)
            ]))
          : (_ctx.students.hasData)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_StudentListTable, {
                  class: "student-list-table",
                  "horizontal-margin": 24,
                  "school-year": _ctx.schoolYear,
                  students: _ctx.students.data,
                  "column-visibility": _ctx.columnVisibility,
                  "link-enabled": false
                }, null, 8, ["school-year", "students", "column-visibility"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
      ])
    ]),
    _createVNode(_component_StudentColumnsSelect, {
      class: "columns-select",
      "school-year": _ctx.schoolYear,
      "column-visibility": _ctx.columnVisibility,
      open: _ctx.isColumnSelectOpen,
      "on-click-collapse-button": _ctx.toggleColumnSelectVisibility,
      "on-change-column-visibility": _ctx.onChangeColumnVisibility
    }, null, 8, ["school-year", "column-visibility", "open", "on-click-collapse-button", "on-change-column-visibility"])
  ]))
}